import { render, staticRenderFns } from "./answer-questions.vue?vue&type=template&id=2a355a22&scoped=true&"
import script from "./answer-questions.vue?vue&type=script&lang=js&"
export * from "./answer-questions.vue?vue&type=script&lang=js&"
import style0 from "./answer-questions.vue?vue&type=style&index=0&id=2a355a22&lang=scss&scoped=true&"
import style1 from "./answer-questions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a355a22",
  null
  
)

export default component.exports